import React, { useState, useEffect } from "react";
import TermsModal from "modals/TermsModal";
import { requestGet } from "utils/AxiosApi";

const Footer = () => {
  //약관 모달창 open
  const [termsModalOpen, setTermsModalOpen] = useState(false);

  const [terms, setTerms] = useState({ seq: 0 });
  const [termsA, setTermsA] = useState({ seq: 0 });
  const [termsB, setTermsB] = useState({ seq: 0 });
  const [termsC, setTermsC] = useState({ seq: 0 });

  const termsModalCallback = (check: boolean, kind: string) => {
    setTermsModalOpen(false);
  };

  const btnShowTerms = (type: String) => {
    if (type === "A") {
      setTerms(termsA);
    } else if (type === "B") {
      setTerms(termsB);
    } else if (type === "C") {
      setTerms(termsC);
    }
    setTermsModalOpen(true);
  };

  const getInitData = async () => {
    var data: any = await requestGet("/api/clause/get/list", {});
    data.map((d: any) => {
      if (d.kind === "A") {
        setTermsA(d);
      } else if (d.kind === "B") {
        setTermsB(d);
      } else if (d.kind === "C") {
        setTermsC(d);
      }
      return d;
    });
  };

  useEffect(() => {
    getInitData();
  }, []);

  return (
    <div>
      <hr></hr>
      <div
        className="div-main-info-form"
        style={{ display: "flex", textAlign: "left" }}
      >
        <div className="div-main-info">
          <h2 id="font-SCD7">COMPANY</h2>
          <div id="font-SCD5">
            <p>파인</p>
            <p>대표 유성철</p>
            <p>사업자등록번호 392-15-01306</p>
            <p>충남 예산군 고덕면 상몽산단2길 73</p>
          </div>
        </div>
        <div className="div-main-info">
          <h2 id="font-SCD7"> INFORMATION</h2>
          <div id="font-SCD5">
            <p>
              <span
                onClick={() => {
                  btnShowTerms("A");
                }}
                style={{ cursor: "pointer" }}
              >
                이용약관
              </span>{" "}
              /{" "}
              <span
                onClick={() => {
                  btnShowTerms("C");
                }}
                style={{ cursor: "pointer" }}
              >
                개인정보처리방침
              </span>
            </p>
            <div style={{ color: "#A6A6A6" }} id="font-SCD4">
              <span>매드몰은 건강기능식품 등 중개거래를</span>
              <span>통해 제공하는 물품에 대하여는 통신판매</span>
              <span>중개자이며, 통신판매의 당사자가 아닙니다.</span>
            </div>
          </div>
        </div>
        <div className="div-main-info">
          <h2 id="font-SCD7">CLIENT CENTER</h2>
          <div id="font-SCD5">
            <p>메일 rsc0530@naver.com</p>
            <p>전화 041-336-6111</p>
          </div>
        </div>
      </div>
      {termsModalOpen && (
        <TermsModal
          setTermsModalOpen={setTermsModalOpen}
          terms={terms}
          termsModalCallback={termsModalCallback}
          footer={true}
        ></TermsModal>
      )}
    </div>
  );
};

export default Footer;
